import React, { useMemo, useState } from "react";
import { Table } from "../../../Components/Table/Table";
import {
  getEmployeeById,
  getEmployeeDocuments,
} from "../../../api/employeeDocument";
import toast from "react-hot-toast";

const SendDetails = () => {
  const [employeeId, setEmployeeId] = useState("");
  const [employeeData, setEmployeeData] = useState(null);
  const [documents, setDocuments] = useState([]);

  /* ================= FETCH DATA ================= */
const handleFetch = async () => {
  if (!employeeId) {
    toast.error("Enter Employee ID ❌");
    return;
  }

  try {
    toast.loading("Fetching data...");

    const empRes = await getEmployeeById(employeeId);
    const docsRes = await getEmployeeDocuments(employeeId);

    const emp = empRes?.data || empRes;
    const docs = docsRes?.data?.data || {};

    if (!emp) {
      toast.dismiss();
      toast.error("Employee not found ❌");
      setEmployeeData(null);
      setDocuments([]);
      return;
    }

    // ✅ convert object → array
    const formattedDocs = Object.entries(docs).flatMap(([type, files]) =>
      files.map((file) => ({
        ...file,
        type,
      }))
    );

    setEmployeeData(emp);
    setDocuments(formattedDocs); // ✅ ONLY THIS

    toast.dismiss();
    toast.success("Data loaded successfully ✅");

  } catch (error) {
    toast.dismiss();
    toast.error("Error fetching data ❌");
  }
};

  /* ================= DATE FORMAT ================= */
  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString();
  };

  const formatTime = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleTimeString();
  };

  /* ================= TABLE ================= */
  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        Cell: ({ row }) => row.index + 1,
      },
     {
  Header: "Document",
  accessor: "type",
  Cell: ({ value }) =>
    value.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase()),
},
      {
        Header: "Date",
        Cell: ({ row }) => formatDate(row.original.uploadedAt),
      },
      {
        Header: "Time",
        Cell: ({ row }) => formatTime(row.original.uploadedAt),
      },
      {
        Header: "Status",
        Cell: ({ row }) =>
          row.original.url ? "Sent" : "Pending",
      },
      {
        Header: "Actions",
        Cell: ({ row }) =>
          row.original.url ? (
            <a href={row.original.url} target="_blank" rel="noreferrer">
              View
            </a>
          ) : (
            "-"
          ),
      },
    ],
    []
  );

  return (
    <>
    <div className="container-admin">
      
        <div className="upload-group employee-search-row">

          {/* LEFT SIDE */}
          <div className="search-left">
            <label>Employee ID</label>
            {/* INPUT */}
            <div className="search-box">
              <input
                type="text"
                value={employeeId}
                onChange={(e) => setEmployeeId(e.target.value)}
                placeholder="Enter Employee ID"
              />
              <button type="button" className="add-btn" onClick={handleFetch}>
                Search
              </button>
            </div>

           
          </div>
           {/* EMPLOYEE CARD */}
            {employeeData && (
              <div className="search-right">
                <img
                  src={employeeData.profileImage || "https://i.pravatar.cc/150"}
                  alt="profile"
                  className="search-emp-img"
                />

                <div className="emp-details">
                  <h4>
                    {employeeData.firstName} {employeeData.lastName}
                  </h4>

                  <p><span>Designation:</span> {employeeData.designation}</p>
                  <p><span>Email:</span> {employeeData.officialmailid}</p>
                  <p><span>Phone:</span> {employeeData.mobilenumber}</p>
                  <p><span>Location:</span> {employeeData.location}</p>
                </div>
              </div>
            )}

          {/* TABLE */}

        </div>
    
      <Table columns={columns} data={documents} />
      </div>
    </>
  );
};

export default SendDetails;